/**
 * This file was created in order to avoid circular imports.
 * Before this, the constant CREHANA_PLAYER_TRANSLATION_KEY was in the src/constants.ts file but that was generating
 * a circular import error: types.ts => constants.ts => types.ts
 * Now, this this file types.ts doesn't need to import from constants.ts file, instead types.ts will import the constanst from i18n/constants.ts file.
 */
export var CREHANA_PLAYER_TRANSLATION_KEY = 'crehana-player';